import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { COPY } from '../copy';
import { currentNavItem } from '../router/currentNavItem';
import { NAV_ITEMS } from '../router/navItems';

/**
 * MUI 9 puts `aria-label` on the inner tablist, so the nav root carries the landmark name itself.
 * `nativeButton={false}` is required: Tab expects a `<button>` unless told the root is a link.
 * The tabs sit on the app bar, where the brand guarantees only appBarInk on appBar, so every label
 * inherits that ink at full opacity (CNPWKS-0007); the indicator marks the current tab.
 * The indicator is `appBarAccent`, guaranteed ≥ 3:1 on the app bar (saas-auth REPLY 2026-10-12).
 * The current tab has a 4 px indicator and a weight-600 label, so it never depends on colour alone
 * (NAV-001, CNPWKS-0011 P3).
 */
export function NavTabs() {
  const { pathname } = useLocation();
  const current = currentNavItem(pathname);

  return (
    <Tabs
      component="nav"
      value={current?.path ?? false}
      role="navigation"
      aria-label={COPY.navLabel}
      slotProps={{ root: { 'aria-label': COPY.navLabel } }}
      textColor="inherit"
      sx={{
        '& .MuiTabs-indicator': {
          bgcolor: 'brandChrome.appBarAccent',
          height: (t) => t.spacing(0.5),
        },
      }}
    >
      {NAV_ITEMS.map(({ path, label, Icon }) => (
        <Tab
          key={path}
          value={path}
          label={label}
          icon={<Icon fontSize="small" />}
          iconPosition="start"
          component={RouterLink}
          to={path}
          nativeButton={false}
          aria-current={current?.path === path ? 'page' : undefined}
          sx={{ opacity: 1, '&.Mui-selected': { fontWeight: 600 } }}
        />
      ))}
    </Tabs>
  );
}
